<template>
    <div ref="wrapper">
        <div :key="tableKey">
            <slot/>
        </div>
    </div>
</template>

<script>
  import sortable from 'sortablejs'

  export default {
    name: 'ElementUiElTableDraggable',
    props: {
      animate: {
        type: Number,
        default: 100
      }
    },
    data () {
      return {
        tableKey: 0
      }
    },
    methods: {
      makeTableSortable () {
        const table = this.$children[0].$el.querySelector(
          '.el-table__body-wrapper tbody'
        )
        sortable.create(table, {
          animation: this.animate,
          forceFallback: true,
          onEnd: ({ newIndex, oldIndex }) => {
            this.keepWrapperHeight(true)
            this.tableKey = Math.random()
            const arr = this.$children[0].data
            const targetRow = arr.splice(oldIndex, 1)[0]
            arr.splice(newIndex, 0, targetRow)
            this.$emit('drop', { targetObject: targetRow, list: arr })
          }
        })
      },
      keepWrapperHeight (keep) {
        const wrapper = this.$refs.wrapper
        if (keep) {
          wrapper.style.minHeight = `${wrapper.clientHeight}px`
        } else {
          wrapper.style.minHeight = 'auto'
        }
      }
    },
    mounted () {
      this.makeTableSortable()
    },
    watch: {
      tableKey () {
        this.$nextTick(() => {
          this.makeTableSortable()
          this.keepWrapperHeight(false)
        })
      }
    }
  }
</script>